import { createSlice } from '@reduxjs/toolkit';
import fetchSections from '../thunk/sections-thunk';

const sectionsSlice = createSlice({
  name: 'sections',
  initialState: {
    sections: [],
    total: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.sections = [];
      state.total = 0;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSections.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSections.fulfilled, (state, action) => {
        state.sections = action.payload;
        state.total = action?.payload?.length;
        state.isLoading = false;
      })
      .addCase(fetchSections.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { reset } = sectionsSlice.actions;

export default sectionsSlice.reducer;
